import { Link } from "react-router-dom";
import { footerGroups, site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 md:mt-20 bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <h2 className="font-brand text-3xl md:text-4xl text-accent-400 leading-none">网曝吃瓜</h2>
            <p className="mt-3 text-sm text-secondary-200 leading-relaxed max-w-md">{site.intro}</p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-sm">
              <a
                href={`mailto:${site.tipEmail}`}
                rel="nofollow"
                className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-send-plane-line" aria-hidden="true" />
                投稿邮箱
              </a>
              <Link
                to="/submit"
                className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-secondary-700 text-background-100 hover:bg-secondary-900 transition-colors whitespace-nowrap"
              >
                <i className="ri-edit-2-line" aria-hidden="true" />
                在线投稿
              </Link>
            </div>
          </div>

          {footerGroups.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <h3 className="text-sm font-bold text-background-50 mb-4 tracking-wide">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© {year} 网曝吃瓜 · 网友爆料投稿聚集地 · 内容以网友投稿为准，仅供参考</p>
          <p className="flex items-center gap-4">
            <span>理性围观 · 来源可溯</span>
            <a href={`mailto:${site.email}`} rel="nofollow" className="hover:text-accent-300 transition-colors">
              {site.email}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}